import { render, staticRenderFns } from "./CadastroContrato.vue?vue&type=template&id=473a6080&scoped=true"
import script from "./CadastroContrato.vue?vue&type=script&lang=js"
export * from "./CadastroContrato.vue?vue&type=script&lang=js"
import style0 from "./CadastroContrato.vue?vue&type=style&index=0&id=473a6080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a6080",
  null
  
)

export default component.exports